/**
 * Proxy utility to transform external URLs to use the player endpoint proxy
 *
 * Proxy mappings:
 * - https://storage.googleapis.com → VUE_APP_PLAYER_ENDPOINT/content-video/gcs/
 * - https://replicate.delivery → VUE_APP_PLAYER_ENDPOINT/content-video/replicate/
 */
import store from "@/store";

const PROXY_MAPPINGS: { source: string; proxy: string }[] = [
  {
    source: "https://storage.googleapis.com",
    proxy: "/gcs"
  },
  {
    source: "https://replicate.delivery",
    proxy: "/replicate"
  }
];

/**
 * Proxify a URL by replacing known external domains with the player endpoint proxy
 * @param url - The original URL to proxify
 * @returns The proxified URL using VUE_APP_PLAYER_ENDPOINT, or the original URL if no mapping found
 */
export function proxify(url: string): string {
  if (!url) {
    return url;
  }

  const playerEndpoint = store.getters.getCdnVideo

  for (const mapping of PROXY_MAPPINGS) {
    if (url.startsWith(mapping.source)) {
      return url.replace(mapping.source, playerEndpoint + mapping.proxy);
    }
  }

  return url;
}
